/* eslint-disable no-console */
const logger = {
  debug: (...args) => console.debug('[ole-spa]', ...args),
  error: (...args) => console.error('[ole-spa]', ...args),
  fatal: (...args) => console.error('[ole-spa]', ...args),
  info: (...args) => console.info('[ole-spa]', ...args),
  trace: (...args) => console.debug('[ole-spa]', ...args),
  warn: (...args) => console.warn('[ole-spa]', ...args),
};

export { logger };
export default logger;
